(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("three-dimensional-light-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["three-dimensional-light-panelless"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["ThreeDimensionalLightPanelless"] = factory();
})(this, () => {
return 